import { createAction, createReducer } from 'redux-act';
export const setLocale = createAction('Set locale');
export const reducer = createReducer({
  [setLocale.getType()]: (state, payload) => payload
}, null);
export const localeSelector = state => state.locale;
export default reducer;